// extracted by mini-css-extract-plugin
export default {"container":"FormEmployee_container__Sh8VO","form":"FormEmployee_form__PtY8X","formBody":"FormEmployee_formBody__nDXFk"};